import { getInitials } from '../../utils/nameUtils';

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Parse the date parts directly; new Date() shifts a day across timezones.
export const fmtDateRange = (start: string | null, end: string | null): string => {
  if (!start) return 'Date TBC';
  const [sy, sm, sd] = start.split('-').map(Number);
  const startStr = `${MONTHS[sm - 1]} ${sd}`;
  if (!end || end === start) return `${startStr}, ${sy}`;
  const [ey, em, ed] = end.split('-').map(Number);
  if (ey !== sy) return `${startStr}, ${sy} - ${MONTHS[em - 1]} ${ed}, ${ey}`;
  const endStr = em === sm ? `${ed}` : `${MONTHS[em - 1]} ${ed}`;
  return `${startStr}-${endStr}, ${sy}`;
};

// Initials avatar; the sources carry no event images. Strip parenthetical asides
// ("(sponsorship reg)") and bare years before the shared initials logic — left as
// words, these produced garbage like "IA(" (a stray paren taken as a word's first
// character) instead of a clean two-letter mark.
export const initials = (name: string): string => {
  const cleaned = name
    .replace(/\([^)]*\)/g, ' ')
    .replace(/\b\d{4}\b/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return getInitials(cleaned || name);
};
